import { compareVersions } from '@sigma-frontend-libs/commons'

import pkg from '../../../package.json'

export default {
  namespaced: true,

  state: {
    new: pkg.version,
    current: pkg.version
  },

  mutations: {
    set(state, value) {
      state.new = value
    }
  },

  actions: {
    async get() {
      try {
        const response = await fetch('/version.json', {
          cache: 'no-store',
          headers: { 'Cache-Control': 'no-cache' }
        })
        if (response?.ok) {
          const data = await response.json()
          if (data?.version) {
            return data.version
          }
        }
      } catch (error) {}
    },

    async set({ commit, dispatch }) {
      const value = await dispatch('get')
      if (value) {
        commit('set', value)
      }
    }
  },

  getters: {
    new: state => state.new,
    current: state => state.current,
    hasNewVersion: state => compareVersions(state.new, state.current) > 0
  }
}
